import AcademyChessClient from "./lilaiframe";
import { pollUntil } from '../../utils/promiseUtils';

const init = () => {
    AcademyChessClient.init();
}

const getSignInResponse = (startTime) => () => new Promise((resolve, reject) => {
    console.log("lilaiframeApi: getSignInResponse", AcademyChessClient.lastResult.auth)
    if (new Date().getTime() - 3000 > startTime) throw new Error("Timeout")
    resolve(AcademyChessClient.lastResult.auth === undefined);
})

const signIn = (credentials) => {
    console.log("lilaiframeApi: signing in!");
    const {l, p} = credentials;

    AcademyChessClient.auth(l, p);

    return pollUntil(getSignInResponse(new Date()), 100)
        .then(() => {
            console.log("lilaiframeApi: Got signIn response")
            console.log("lilaiframeApi: AcademyChessClient.lastResult.auth=", AcademyChessClient.lastResult.auth)
            if (AcademyChessClient.lastResult.auth === "onLoginSuccess")
                return {
                    status: "ok",
                }
            return {status: "error", details: "Couldn't login"}
        }).catch((e) => {
            return {status: "error", details: e && e.toString()}
        })
}

const isInited = () => {
    console.log('lilaiframeApi: isInited() AcademyChessClient.lastResult.inited:',AcademyChessClient.lastResult.inited)
    return AcademyChessClient.lastResult.inited;
}

export default {
    init,
    signIn,
    isInited
}
